<template>
  <div class="about">
    <ith-top-bar />
    <div style="height: 100px"></div>

    <div style="height: 100px"></div>
    <div
      id="appleid-signin"
      style="height: 30px"
      data-color="black"
      data-border="true"
      data-type="sign in"
    ></div>
    <ith-footer />
  </div>
</template>

<script>
export default {
  data: () => ({
    act_route: [],
    alert: { color: "", message: "" },
  }),
  created() {
    this.$store.commit("DISABLED_MENU");

    document.addEventListener("AppleIDSignInOnSuccess", (data) => {
      this.loginApple(data);
    });
  },

  methods: {
    async loginApple(data) {
      let auth = data.detail.authorization.id_token;
      let user_id = [];
      try {
        user_id = JSON.parse(atob(auth.split(".")[1]));
      } catch (e) {
        return null;
      }

      let authData = {
        authData: {
          id: user_id.sub,
          token: auth,
        },
      };
      await this.$Parse.User.logInWith("apple", authData);
    },
  },
};
</script>

<style scoped>
.about {
  background-color: #2c3848;
}
</style>
